export default {
    bodyTemperature: "Body Temperature",
    pulse: "Pulse",
    leftHandBloodPressure: "Left Hand Blood Pressure",
    rightHandBloodPressure: "Right Hand Blood Pressure"
}